import PropTypes from "prop-types"
import React, { useState, memo } from "react"
import { useStore } from "../../teafuljs/store"
import { navigate } from "gatsby"

import { makeStyles } from "@material-ui/core/styles"
import AppBar from "@material-ui/core/AppBar"
import Toolbar from "@material-ui/core/Toolbar"
import IconButton from "@material-ui/core/IconButton"
import MenuIcon from "@material-ui/icons/Menu"
import Share from "@material-ui/icons/Share"
import Visibility from "@material-ui/icons/Visibility"
import ArrowBackIos from "@material-ui/icons/ArrowBackIos"
import Search from "@material-ui/icons/Search"
import SearchPanel from "../SearchPanel/SearchPanel"
import MenuDrawer from "../Menu/Menu"
import Drawer from "@material-ui/core/Drawer"
import Typography from "@material-ui/core/Typography"
import Popover from "@material-ui/core/Popover"
import DisplaySettings from "../DisplaySettings/DisplaySettings"
import SegmentSelect from "../AutoComplete/SegmentSelect"
import SegmentTitles from "../../data/SegmentTitles.json"
import { getTranslation } from "../../scripts/getTranslation"
import Menu from "@material-ui/core/Menu"
import BookNameData from "../../data/BookChapterList.json"
import { recordEvent } from "../../apis/googleAnalytics"
import SVBLogo from "../../../static/images/SVLogo.jpeg"
import SphereViewLogo from "../../../static/images/SphereViewCarouselcircle.png"

const useStyles = makeStyles({
  toolBar: {
    justifyContent: "stretch",
  },
  icons: {
    margin: 3,
  },
  buttonGroups: {
    flex: "1 1 100px",
    display: "flex",
  },
  segmentSelect: {
    flex: "1 1 100px",
    position: "relative",
    height: "100%",
    paddingTop: "6px",
    maxWidth: "50vw",
  },
  startButtons: {
    display: "flex",
  },
  endButtons: {
    justifyContent: "flex-end",
  },
  titleRef: {
    color: `white`,
    textDecoration: `none`,
    width: "fit-content",
    textAlign: "center",
    padding: 0,
  },
  headerTitleContainer: {
    display: 'flex',
    maxHeight: 50,
    flexDirection: "row",
    justifyContent: "center",
    alignItems: "center",
  },
  headerTitle: {
    display: "flex",
    alignItems: "center",
    flexDirection: "column",
  },
  title: {
    color: `white`,
    textDecoration: `none`,
    flex: "10",
    flexGrow: 0.5,
    textAlign: "center",
  },
  logoInTitle: {
    height: 30,
    width: 30,
    borderRadius: 15,
    marginRight: 10,
    marginTop: 20
  },
})

const Header = memo(({ currentLocation }) => {
  const [language, setLanguage] = useStore.language();
  const [version, setVersion] = useStore.version();
  const [currentSegmentID, setCurrentSegmentID] = useStore.currentSegmentID();
  const [history, setHistory] = useStore.history();
  const setSearchID = useStore.searchID()[1];
  const AvailableContent = useStore.AvailableContent()[0]
  const translations = useStore.translations()[0]
  const segmentOrder = useStore.segmentOrder()[0]
  const classes = useStyles()
  // This controls the visibility of chapter and verse references
  const [menu, updateMenu] = useState(false)
  const [searchMenu, updateSearchMenu] = useState(false)
  function openSearchMenu() {
    updateSearchMenu(true)
  }

  //PopOver Layers toggling open and closed
  const [layerPopup, updateLayerPopup] = React.useState(null)

  function handleClick(event) {
    updateLayerPopup(event.currentTarget)
  }

  function layerHandleClose() {
    updateLayerPopup(null)
  }
  const [selectSegmentMenu, setSelectSegmentMenu] = React.useState(null)

  const handleSegmentClick = event => {
    setSelectSegmentMenu(event.currentTarget)
  }

  const handleSegmentClose = () => {
    setSelectSegmentMenu(null)
  }

  const layerOpen = Boolean(layerPopup)
  const layerId = layerOpen ? "simple-popover" : undefined

  const versificationType =
    AvailableContent &&
    AvailableContent.content[language] &&
    AvailableContent.content[language].versions[version] &&
    AvailableContent.content[language].versions[version].versification
      ? AvailableContent.content[language].versions[version].versification
      : "standard"

  const HeaderTitle = segmentData => {
    const reference = getRef(segmentData.segmentData)
    return (
      <div className={classes.headerTitle}>
        <Typography
          variant="subtitle2"
          // noWrap
          className={classes.titleRef}
          onClick={handleSegmentClick}
        >
          {reference.book}
        </Typography>
        <Typography
          variant="subtitle2"
          // noWrap
          className={classes.titleRef}
          onClick={handleSegmentClick}
        >
          {reference.ref}
        </Typography>
      </div>
    )
  }

  function getRef(segmentData) {
    if (segmentData.book.length > 1) {
      return {
        book: `${getTranslation(
          translations,
          language,
          "Books",
          BookNameData[segmentData.book[0]].bookName
        )} ${
          versificationType === "standard" && segmentData.standardRef
            ? segmentData.standardRef.split("-")[0]
            : segmentData.ref.split("-")[0]
        } -`,
        ref: `${getTranslation(
          translations,
          language,
          "Books",
          BookNameData[segmentData.book[1]].bookName
        )} ${
          versificationType === "standard" && segmentData.standardRef
            ? segmentData.standardRef.split("-")[1]
            : segmentData.ref.split("-")[1]
        }`,
      }
    } else {
      return {
        book: getTranslation(
          translations,
          language,
          "Books",
          BookNameData[segmentData.book[0]].bookName
        ),
        ref:
          versificationType === "standard" && segmentData.standardRef
            ? segmentData.standardRef
            : segmentData.ref,
      }
    }
  }

  function goBack() {
    const previousPageInfo = { ...history[0] }
    if (language !== previousPageInfo.language) {
      setLanguage(previousPageInfo.language)
    }
    if (version !== previousPageInfo.version) {
      setVersion(previousPageInfo.version)
    }
    if (currentSegmentID !== previousPageInfo.segment) {
      setCurrentSegmentID(previousPageInfo.segment)
    }
    if (currentLocation.pathname !== previousPageInfo.page) {
      navigate(previousPageInfo.page)
    } else if (previousPageInfo.scrollY !== window.scrollY) {
      // window.scrollTo(0, previousPageInfo.scrollY)
    }
    const lastScrollY = history[0] ? history[0].scrollY : 0
    history.shift()
    setHistory(history);
    setSearchID(lastScrollY);
  }

  return (
    <AppBar position="fixed">
      <Toolbar className={classes.toolBar}>
        <div className={`${classes.buttonGroups} ${classes.startButtons}`}>
          <IconButton
            className={classes.icons}
            size="small"
            color="inherit"
            aria-label="Menu"
            onClick={() => updateMenu(true)}
          >
            <MenuIcon />
          </IconButton>
          {navigator.share ? (
            <IconButton
              id="share-page"
              className={classes.icons}
              size="small"
              color="inherit"
              aria-label="Menu"
              onClick={() => {
                const sharedRef = getRef(SegmentTitles[currentSegmentID])
                navigator
                  .share({
                    title: getTranslation(
                      translations,
                      language,
                      "Titles",
                      "home_title1"
                    ),
                    text: `${getTranslation(
                      translations,
                      language,
                      "Titles",
                      currentSegmentID
                    )} (${sharedRef.book} ${sharedRef.ref} ${version})`,
                    url: window.location.href,
                  })
                  .then(() => {
                    recordEvent(
                      "Share",
                      `${language}-${version}`,
                      currentSegmentID
                    )
                    console.log("Successfully shared")
                  })
                  .catch(error => console.log("Error sharing:", error))
              }}
            >
              <Share id="share-page" />
            </IconButton>
          ) : null}
        </div>
        <div className={`${classes.segmentSelect}`}>
          {currentLocation.pathname.substring(0, 7) === "/reader" ? (
            <React.Fragment>
              <HeaderTitle segmentData={SegmentTitles[currentSegmentID]} />
              <Menu
                id="simple-menu"
                anchorEl={selectSegmentMenu}
                keepMounted={true}
                open={Boolean(selectSegmentMenu)}
                onClose={handleSegmentClose}
              >
                {AvailableContent && (
                  <SegmentSelect
                    closeSegmentSelect={handleSegmentClose}
                    language={language}
                    version={version}
                    translations={translations}
                    currentSegmentID={currentSegmentID}
                    content={AvailableContent.content[language][version]}
                    segmentOrder={segmentOrder}
                    versificationType={versificationType}
                  />
                )}
              </Menu>
            </React.Fragment>
          ) : (
            <div className={classes.headerTitleContainer}>
              <img
                className={classes.logoInTitle}
                src={currentLocation.pathname.substring(0, 11) === "/sphereView"
                    ? SphereViewLogo
                    : SVBLogo}
                alt="SVB Logo"
              />
              <Typography
                variant="subtitle2"
                className={classes.title}
                onClick={() => navigate("/")}
              >
                {getTranslation(
                  translations,
                  language,
                  "UI",
                  currentLocation.pathname.substring(0, 11) === "/sphereView"
                    ? "layers_sphereview"
                    : "home_title1"
                )}
              </Typography>
            </div>
          )}
        </div>
        <div className={`${classes.buttonGroups} ${classes.endButtons}`}>
          {history.length > 0 && (
            <IconButton
              className={classes.icons}
              size="small"
              color="inherit"
              aria-label="Menu"
              onClick={() => goBack()}
            >
              <ArrowBackIos id="back" />
            </IconButton>
          )}
          {AvailableContent &&
          currentLocation.pathname.substring(0, 7) === "/reader" ? (
            <React.Fragment>
              <IconButton
                className={classes.icons}
                size="small"
                color="inherit"
                aria-label="Menu"
                onClick={handleClick}
              >
                <Visibility id="verse-view-off" />
              </IconButton>
              <Popover
                id={layerId}
                open={layerOpen}
                anchorEl={layerPopup}
                onClose={layerHandleClose}
                anchorOrigin={{
                  vertical: "bottom",
                  horizontal: "center",
                }}
                transformOrigin={{
                  vertical: "top",
                  horizontal: "center",
                }}
              >
                <DisplaySettings />
              </Popover>
            </React.Fragment>
          ) : null}
          {currentLocation.pathname.substring(0, 7) === "/reader" ? (
            <IconButton
              id="search-nav-click"
              className={classes.icons}
              size="small"
              color="inherit"
              aria-label="Menu"
              onClick={() => openSearchMenu()}
            >
              <Search id="search-nav-click" />
            </IconButton>
          ) : null}
        </div>
      </Toolbar>
      <Drawer
        className={classes.drawer}
        open={menu}
        anchor="left"
        width="75%"
        onClose={() => updateMenu(false)}
      >
        <MenuDrawer
          location={currentLocation}
          closeMenu={() => updateMenu(false)}
        />
      </Drawer>
      <Drawer
        className={classes.drawer}
        open={searchMenu}
        anchor="right"
        // width={200}
        onClose={() => updateSearchMenu(false)}
      >
        <SearchPanel
          currentLocation={currentLocation.pathname}
          closeSearchMenu={() => updateSearchMenu(false)}
        />
      </Drawer>
    </AppBar>
  )
})

Header.propTypes = {
  siteTitle: PropTypes.string,
}

Header.defaultProps = {
  siteTitle: ``,
}

export default Header
